import React from 'react';

interface AddressInfoProps {
  name: string;
  phone: string;
  address: string;
  showEditButton?: boolean;
  onEdit: () => void;
}

const AddressInfo: React.FC<AddressInfoProps> = ({
  name,
  phone,
  address,
  showEditButton = true,
  onEdit,
}) => {
  return (
    <div className="flex items-center">
      <div className="flex flex-col flex-1 items-start space-y-2">
        <div className="flex space-x-1 text-xl">
          <div className="font-semibold">{name}</div>
          <div>.</div>
          <div>{phone}</div>
        </div>
        <div className="text-left text-ellipsis truncate w-[270px] text-2xl">
          {address}
        </div>
      </div>
      {showEditButton && (
        <button
          className="text-xl font-semibold text-[#2962FF]"
          onClick={onEdit}
        >
          Edit
        </button>
      )}
    </div>
  );
};

export default AddressInfo;
